export default {
	"components.UnbindAccount": "Unbind account"
}